import React, { useState, useRef } from 'react'
import { ImageUploader } from '../image-uploader'
import { Spinner, SpinnerSize } from '@fluentui/react'
import { toast } from 'react-toastify'
import api from '../../api-client'
import { StatusData, errorToString, SolarDocStatus, UploadedDoc, MimeTypes } from '@oneethos/shared'

type AdditionalDocumentUploadProps = {
  project: StatusData
  onChange: (p: StatusData) => void
  uploadType: string
}

export const AdditionalDocumentUpload = ({
  project,
  onChange,
  uploadType,
}: AdditionalDocumentUploadProps) => {
  const [docs, setDocs] = useState<UploadedDoc[]>([])
  const [notes, setNotes] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const fileInputRef = useRef<HTMLInputElement>(null)

  const handleFileChange = (doc: UploadedDoc, status?: SolarDocStatus) => {
    if (status === SolarDocStatus.Uploaded) {
      setDocs([{ ...doc, label: 'Other' }])
    }
  }

  const onSubmit = () => {
    setSubmitting(true)

    return api.put(`/loanapps/${project.id}/docs/submit`, {
      uploadType,
      documents: docs,
      notes
    }).then(p => {
      const proj = new StatusData(p)
      proj.uiSort()
      toast.success('Document submitted successfully. You can view them in the History tab.')
      onChange(proj)
    }).catch(ex => toast.error(errorToString(ex)))
      .finally(() => setSubmitting(false))
  }

  return (
    <>
      <div className='d-flex justify-content-between my-2'>
        <div className=" mb-3">
          <p className="fw-bold mb-2">Other</p>
          You may upload other documents if needed.
        </div>
        <ImageUploader
          ref={fileInputRef}
          doc={docs[0]}
          onChange={handleFileChange}
          acceptContentTypes={MimeTypes.allowedUploadExtensions().join(',')}
        />
      </div>
      <div className='pt-3'>
        <div>Please provide a detailed explanation of the uploaded documents:</div>
        <textarea
          className="form-control mt-1"
          value={notes}
          onChange={(ev) => setNotes(ev.target.value)}
          maxLength={200}
        />
        <p className="small text-secondary">{notes.length} / 200 characters</p>
      </div>
      <div className='text-center'>
        <button
          type="button"
          className="btn btn-primary"
          disabled={docs.length === 0 || submitting}
          onClick={onSubmit}
        >
          {submitting ? <Spinner size={SpinnerSize.small} /> : 'Submit'}
        </button>
      </div>
    </>
  )
}

export default AdditionalDocumentUpload
